import { useEffect } from 'react';

import { Box, Stack, Typography } from '@mui/material';

import StatusBar from '@/designs-dev/device/StatusBar';
import HomeIndicator from '@/designs-dev/device/HomeIndicator';

// Interstitial after the set-password step: the logo mark loader (animated
// SVG in public/vector) while the account is 'created', then on to the
// access questions.
const AccountLoadingScreen = ({ onContinue }: { onContinue: () => void }) => {
  useEffect(() => {
    const t = window.setTimeout(onContinue, 2600);
    return () => window.clearTimeout(t);
  }, [onContinue]);

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
      }}
    >
      <StatusBar />
      <Stack
        sx={{ flex: 1, alignItems: 'center', justifyContent: 'center', px: 3 }}
        spacing={3}
      >
        <Box
          sx={{ width: 64, height: 62 }}
          component='img'
          src='/vector/karehero-loader.svg'
          alt=''
        />
        <Typography
          sx={{ textAlign: 'center', color: 'custom.marineGreen.500' }}
          variant='h3'
        >
          Setting up your account
        </Typography>
      </Stack>
      <HomeIndicator />
    </Box>
  );
};

export default AccountLoadingScreen;
